<template>
  <div v-if="!disableSearch || !disableControls"
       class="select__controls"
       :class="{'select__controls--shadow': topShadow }"
  >
    <FormControl
        v-if="!disableSearch"
        v-model="request.search"
        :placeholder="$t('front.search')"
        input-group-class="input-group--pill"
        label-disabled
    >
      <template #prefix>
        <i class="icon-search"/>
      </template>
    </FormControl>

    <div v-if="showControls"
         class="controls"
    >
      <a href="#"
         @click.prevent="emit('all', 1)"
      >
        {{ $t('front.select_all') }}
      </a>
      <span class="vr mx-3"></span>
      <a href="#"
         @click.prevent="emit('all', 0)"
      >
        {{ $t('front.deselect_all') }}
      </a>
    </div>

    <div v-if="action" class="ms-auto">
      <Button v-tooltip="action?.tooltip || action.title"
              @click="callAction(action)"
      >
        <i v-if="action.icon" class="icon" :class="[action.icon, { 'me-2': action.title}]" />
        {{ action.title }}
      </Button>
    </div>
  </div>


  <SelectOptions
      ref="optionsRef"
      v-bind="mappedOptionsProps"
      @select="onSelect"
      @scrollStart="onScrollStart"
      @scroll="onScroll"
      @scrollEnd="onScrollEnd"
  >
    <template #option="data">
      <slot name="option" v-bind="data" />
    </template>
    <template #emptyList="data">
      <slot name="emptyList" v-bind="data" />
    </template>
  </SelectOptions>
</template>
<script setup>
import FormControl from "@/js/Elements/Form/FormControl.vue";
import Button from "@/js/Elements/Button.vue";
import {useAction} from "@/js/Plugins/Action.js";
import SelectOptions from "@/js/Elements/Select/SelectOptions.vue";
import {computed, ref} from "vue";

const callAction = useAction();

const emit = defineEmits(['all', 'apply'])
const props = defineProps({
  disableSearch: Boolean,
  disableControls: Boolean,
  request: Object,
  multiple: Boolean,
  action: Array,
  optionsProps: Object,
  isStatic: Boolean,
  showGoToPage: Boolean,
});

const optionsRef = ref();
let onSelectCallback = null;
const topShadow = ref(false);

const mappedOptionsProps = computed(() => {
  onScrollEnd(optionsRef.value && optionsRef.value.isScrollable())
  if (props.optionsProps.onSelect) {
    onSelectCallback = props.optionsProps.onSelect;
    delete props.optionsProps.onSelect;
  }
  return props.optionsProps;
});

const showControls = computed(() => {
  return (props.multiple && props.isStatic) || props.request.select;
});

function onSelect(option) {
  onSelectCallback(option);
  emit('apply');
}

function onScrollStart() {
  topShadow.value = false;
}

function onScroll() {
  topShadow.value = true;
}

function onScrollEnd(scrollable) {
  topShadow.value = scrollable;
}
</script>
<style lang="scss" scoped>
@import "@/css/functions";
@import "@/css/variables";


.select__controls {
  display: flex;
  align-items: center;
  padding: spacing(4) spacing(2) spacing(3) spacing(2);
  gap: spacing(2);

  &--shadow {
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    position: relative;
    z-index: 2;
  }

  .controls {
    height: toRem(20);
    display: flex;
    align-items: center;
    margin-left: spacing(5);
  }

  &:deep(.input-group) {
    width: 100%;
    max-width: toRem(250);
  }

  a {
    text-decoration: none;
    font-weight: $font-weight-medium;
    font-size: fontSize(4);
  }
}
</style>